import React, { useEffect, useState } from "react";
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";

function Counterup() {
  const [aboutData, setAboutData] = useState(null);
  const [loading, setLoading] = useState(true);

  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.25,
  });

  const API_BASE_URL = (
    process.env.REACT_APP_API_BASE_URL || "http://localhost:5000"
  ).replace(/\/+$/, "");

  useEffect(() => {
    const controller = new AbortController();

    const fetchCounterData = async () => {
      try {
        setLoading(true);

        const searchParams = new URLSearchParams(window.location.search);

        const currentLang = searchParams.get("lang") || "tr";

        const response = await fetch(
          `${API_BASE_URL}/api/about/about?lang=${encodeURIComponent(
            currentLang,
          )}`,
          {
            method: "GET",
            headers: {
              Accept: "application/json",
            },
            signal: controller.signal,
          },
        );

        if (!response.ok) {
          throw new Error(`Sayaç verileri alınamadı: ${response.status}`);
        }

        const data = await response.json();

        setAboutData(data || null);
      } catch (error) {
        if (error.name !== "AbortError") {
          console.error("COUNTER_API_ERROR:", error);
          setAboutData(null);
        }
      } finally {
        if (!controller.signal.aborted) {
          setLoading(false);
        }
      }
    };

    fetchCounterData();

    return () => {
      controller.abort();
    };
  }, [API_BASE_URL]);

  /*
   * API değerleri "1000", "18000" gibi string
   * gelebileceği için sayıya dönüştürür.
   */
  const convertToNumber = (value) => {
    if (value === null || value === undefined) {
      return 0;
    }

    if (typeof value === "number") {
      return value;
    }

    const cleanedValue = String(value).replace(/[^\d]/g, "");

    return Number(cleanedValue) || 0;
  };

  const hasPlus = (value) => {
    return String(value || "").includes("+");
  };

  const counters = [
    {
      id: 1,
      icon: "fas fa-handshake",
      value: convertToNumber(aboutData?.personel),
      hasPlus: hasPlus(aboutData?.personel),
      label: "MÜŞTERİ",
    },
    {
      id: 2,
      icon: "fas fa-industry",
      value: convertToNumber(aboutData?.firma),
      hasPlus: hasPlus(aboutData?.firma),
      label: "Ton/Yıl",
    },
    {
      id: 3,
      icon: "fas fa-users",
      value: convertToNumber(aboutData?.sanayi),
      hasPlus: hasPlus(aboutData?.sanayi),
      label: "Çalışan",
    },
    {
      id: 4,
      icon: "fas fa-solar-panel",
      value: convertToNumber(aboutData?.kwh),
      hasPlus: hasPlus(aboutData?.kwh),
      label: "kWh",
    },
  ];

  if (loading) {
    return null;
  }

  if (!aboutData) {
    return null;
  }

  return (
    <section ref={ref} className="demirsan-counter-section">
      <style>
        {`
          .demirsan-counter-section {
            width: 100%;
            height: auto !important;
            min-height: 0 !important;

            margin: 0;
            padding: 55px 0 !important;

            overflow: hidden;

            background: #0d121c;
            background-image: none !important;
          }

          .demirsan-counter-section .counter-row {
            align-items: stretch;
          }

          .demirsan-counter-section .counter-column {
            display: flex;
          }

          .demirsan-counter-section .counter-box {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;

            width: 100%;
            min-height: 190px;

            padding: 20px 15px;

            text-align: center;
          }

.demirsan-counter-section .counter-icon {
  display: flex;
  align-items: center;
  justify-content: center;

  width: 82px;
  height: 82px;

  margin-bottom: 18px;

  color: #df0a0a;

  border: 2px solid rgba(255, 255, 255, 0.18);
  border-radius: 50%;

  font-size: 37px;
}
          .demirsan-counter-section .counter-number {
            margin: 0 0 8px;

            color: #ffffff;

            font-size: 42px;
            font-weight: 700;
            line-height: 1;
          }

          .demirsan-counter-section .counter-label {
            margin: 0;

            color: #ffffff;

            font-size: 16px;
            font-weight: 600;
            line-height: 1.4;
            text-transform: uppercase;
          }

          @media (min-width: 992px) {
            .demirsan-counter-section
              .counter-column:not(:last-child) {
              border-right:
                1px solid rgba(255, 255, 255, 0.12);
            }
          }

          @media (max-width: 991px) {
            .demirsan-counter-section {
              padding: 40px 0 !important;
            }

            .demirsan-counter-section .counter-box {
              min-height: 180px;
            }
          }

          @media (max-width: 575px) {
            .demirsan-counter-section {
              padding: 30px 0 !important;
            }

            .demirsan-counter-section .counter-box {
              min-height: 160px;
              padding: 15px 10px;
            }

            .demirsan-counter-section .counter-icon {
            width: 68px;
height: 68px;
font-size: 30px;

              margin-bottom: 14px;

        
            }

            .demirsan-counter-section .counter-number {
              font-size: 34px;
            }

            .demirsan-counter-section .counter-label {
              font-size: 14px;
            }
          }
        `}
      </style>

      <div className="container">
        <div className="row counter-row">
          {counters.map((item) => (
            <div
              className="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12 counter-column"
              key={item.id}
            >
              <div className="counter-box">
                <div className="counter-icon">
                  <i className={item.icon} />
                </div>

                <h2 className="counter-number">
                  {inView ? (
                    <>
                      <CountUp
                        start={0}
                        end={item.value}
                        duration={1.5}
                        separator="."
                      />
                      {item.hasPlus && "+"}
                    </>
                  ) : (
                    "0"
                  )}
                </h2>

                <p className="counter-label">{item.label}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Counterup;
